import axios from 'axios';
import apisUrls from '../urls';

const toggleAdminApi = (data) => {
  return axios.post(apisUrls?.toggleAdmin, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default toggleAdminApi;
